// Orders list urgency highlighting, per parrot-media/portal/main#331.
//
// Bud Mertz (2026-09-25): next-day-air orders that have not shipped are red
// regardless of age; every other unshipped order turns orange once it is more
// than four hours old. Red wins over orange.
//
// The readings below are the ones proposed in #331 and are pending Bud's
// confirmation; each is a one-line change here.

// A next-day service is matched on the carrier and the service name the list
// row already carries (shipped_with_name and shipping_type_name), not on
// shipping_type ids: ids are assigned by sequence in each environment, so dev
// and production disagree on them (dev id 1 is a test carrier's "One-Day
// Delivery"). Service names repeat across carriers, so the carrier must match
// as well. In production this selects, by name:
//   UPS    Next Day Air (1DA), Next Day Air Early (1DM), Next Day Air Saver (1DP)
//   FedEx  Priority Overnight (PO), First Overnight (FO), Standard Overnight (SO)
// Bud named all of these except Next Day Air Saver; if he excludes it, change
// the pattern to /next day air(?! saver)|overnight/i.
export const NEXT_DAY_CARRIERS = ['UPS', 'FedEx'];
export const NEXT_DAY_METHOD_PATTERN = /next day air|overnight/i;

// order_status ids that count as "not shipped" for highlighting: Pending (1),
// In Progress (2), Ready to Ship (6), In Production (7), Needs Review (8).
// Cancelled (3), Shipped (4), Archived (5) and Cancelled by Shopify (9) are
// excluded: Archived is the terminal state for all completed work, so
// including it would light up every historic order forever.
export const UNSHIPPED_STATUS_IDS = [1, 2, 6, 7, 8];

// How long an unshipped order may wait before it is flagged. The clock starts
// at created_on, the documented business date, which is populated in every
// era (shipped_on is set on well under 1% of orders and is not usable).
export const AGED_ORDER_HOURS = 4;
export const AGED_ORDER_MS = AGED_ORDER_HOURS * 60 * 60 * 1000;

export const ORDER_URGENCY = {
    NEXT_DAY: 'next_day',
    AGED: 'aged'
};

// Whole-row styles. The row is tinted rather than recoloured so the text keeps
// its normal contrast; the next-day row is also bolded so the two states differ
// by weight as well as hue. The icon in the urgency column carries the strong
// colour and a distinct shape per state for colour-blind users.
export const ORDER_URGENCY_STYLES = {
    [ORDER_URGENCY.NEXT_DAY]: {backgroundColor: 'rgba(180, 33, 45, 0.14)', fontWeight: 600},
    [ORDER_URGENCY.AGED]: {backgroundColor: 'rgba(239, 108, 0, 0.16)'}
};

// Icon colours: the theme's errorColor red and Material orange 800.
export const ORDER_URGENCY_COLORS = {
    [ORDER_URGENCY.NEXT_DAY]: '#b4212d',
    [ORDER_URGENCY.AGED]: '#ef6c00'
};

export const ORDER_URGENCY_LABELS = {
    [ORDER_URGENCY.NEXT_DAY]: 'Next-day air, not yet shipped',
    [ORDER_URGENCY.AGED]: `Not shipped after ${AGED_ORDER_HOURS} hours`
};
